import { graphql } from "gatsby"
import React from "react"
import CardModule from "../components/cardModule"
import CtaModule from "../components/ctaModule"
import HeroBanner from "../components/heroBanner"
import InformationModule from "../components/informationModule"
import Layout from "../components/layout"
import SEO from "../components/seo"
import TextModule from "../components/textModule"

const ModularPage = ({ data: { modularPage } }) => {
  const { contentBlocks } = modularPage || {}
  const hero = contentBlocks?.find(block => block?.id?.includes("Hero"))

  return (
    <Layout comingSoon={false} fixedButton={hero?.buttonText} fixed={hero} fixedTitle={hero?.caption} fixedCaption={hero?.caption} fixedLink={hero?.buttonLink}>
      {contentBlocks?.map(block => {
        if (block?.id?.includes("Hero")) return <HeroBanner key={block?.id} title={block?.title} video={block?.video} image={block?.image} fixedTitle={block?.caption} fixedCaption={block?.caption} buttonText={block?.buttonText} link={block?.buttonLink} />
        if (block?.id?.includes("Text")) return <TextModule key={block?.id} heading={block?.heading} subheading={block?.subheading} description={block?.description} showTopLine={block?.showTopLine} />
        if (block?.id?.includes("Card")) return <CardModule key={block?.id} title={block?.title} description={block?.description} cards={block?.cards} />
        if (block?.id?.includes("Cta")) return <CtaModule key={block?.id} title={block?.title} buttonText={block?.buttonText} buttonLink={block?.buttonLink} video={block?.video} image={block?.image} />
        if (block?.id?.includes("Information")) return <InformationModule key={block?.id} title={block?.title} description={block?.description} image={block?.image} blocks={block?.blocks} />
        return null
      })}
    </Layout>
  )
}

export const Head = ({ data: { modularPage } }) => {
  const { seo } = modularPage || {}
  return <SEO title={seo?.title} description={seo?.description} image={seo?.image?.url} />
}

export const query = graphql`
  query ModularPageQuery($slug: String!) {
    modularPage: datoCmsModularPage(slug: { eq: $slug }) {
      id
      pageTitle
      seo {
        title
        description
        image {
          url
        }
      }
      contentBlocks {
        ... on DatoCmsText {
          id
          subheading
          showTopLine
          heading
          description
        }
        ... on DatoCmsHero {
          id
          video
          title
          caption
          buttonText
          buttonLink
          image {
            url
            gatsbyImageData
          }
        }
        ... on DatoCmsCardModule {
          id
          title
          description
          cards {
            id
            title
            description
            image {
              gatsbyImageData
            }
          }
        }
        ... on DatoCmsCta {
          id
          title
          buttonText
          buttonLink
          video
          image {
            gatsbyImageData
          }
        }
        ... on DatoCmsInformationModule {
          id
          title
          description
          image {
            gatsbyImageData
          }
          blocks {
            id
            listItems {
              ... on DatoCmsContent {
                id
                content
              }
              ... on DatoCmsLinkText {
                id
                text
              }
              ... on DatoCmsSubheading {
                id
                title
                isLight
              }
            }
          }
        }
      }
    }
  }
`

export default ModularPage
